import script from "./NewUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUserView.vue?vue&type=script&setup=true&lang=js"

import "./NewUserView.vue?vue&type=style&index=0&id=44c9c49f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c9c49f"]])

export default __exports__